export default {
  LEGAL_PERSON: "legalPerson",
  NATURAL_PERSON: "naturalPerson",
}
